import { unwrapResult } from "@reduxjs/toolkit";
import React from "react";
import { AiOutlinePlus } from "@react-icons/all-files/ai/AiOutlinePlus";

import { useInView } from "react-intersection-observer";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { createComment } from "../../../../3- actions/comments";
import { getUserComment } from "../../../../3- actions/users";

import Loadinguser from "../../../../components/Loadingnovel";
import SuccessEye from "../../../../components/Nav & Header/EyeNoData";

function WriteReplyReviewForm({
  allCommentUsers,
  currentNovel,
  currentComment,
  userId,
  commentId,
  setReplieCommentPopUp,
  replieCommentPopup,
}) {
  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  const usersList = allCommentUsers?.users?.filter(
    (Usercomment) => Usercomment._id === userId
  );
  const { id } = useParams();
  const dispatch = useDispatch();

  const [submitComment, setSubmitComment] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [replyCommentForm, setReplyCommentForm] = React.useState({
    comment: "",
    Replie_id: "",
    ReplieX2_id: "",
    User_name: "",
    User_picture: "",
    Novel_picture: "",
    Novel_title: "",
    Novel_id: "",
    likes: [],
    approved: false,
  });

  const [successPopUp, setSuccessPopUp] = React.useState(false);
  const clear = () => {
    setReplyCommentForm({
      comment: "",
      Replie_id: "",
      ReplieX2_id: "",
      Novel_id: "",
      likes: 0,
      approved: false,
    });
  };
  function handleSubmit(e) {
    e.preventDefault();
    setSubmitComment(true);
    var commentInput = replyCommentForm.comment.trim();
    if (commentInput?.length < 50) {
      setError(true);
      setSubmitComment(false);
    } else {
      dispatch(createComment(replyCommentForm))
        .then(unwrapResult)
        .then((obj) => {
          // second dispatch is important because you tell
          // the api to post a request that contains user_id FROM THE COMMENT U CREATED
          // so he can bring me the user, so i can match him with the comment
          dispatch(getUserComment([obj.User_id]));
          clear();
          setSubmitComment(false);
          setReplieCommentPopUp(false);
          setSuccessPopUp(true);
        });
    }
  }
  let successmessage = (
    // Get started popup
    <div>
      <div
        className={
          successPopUp
            ? "-translate-y-[0%] opacity-100  w-full md:w-full lg:w-[75%] xl:w-[60%]  2xl:w-[50%] h-full md:h-[80%] m-auto duration-500 ease-in-out fixed inset-0 z-[10000] flex justify-center items-center"
            : "translate-y-[200%] opacity-0  w-full md:w-full lg:w-[75%] xl:w-[60%]  2xl:w-[50%] h-full md:h-[80%] m-auto duration-500 ease-in-out fixed inset-0 z-[10000] flex justify-center items-center"
        }
      >
        <div className="w-full md:w-full lg:w-full xl:w-full  2xl:w-full h-full md:h-full">
          <div className=" bg-tertiary relative md:static overflow-y-scrsoll z-[1000] w-full md:w-full lg:w-full xl:w-full 2xl:w-full h-full md:h-full duration-500 ease-in-out">
            <div className=" bg-primary py-[100px] md:py-16 px-[15px]  gap-y-4 md:px-0 w-full  flex justify-center items-center flex-col text-center ">
              <div className="successZoom">
                <SuccessEye />
              </div>
              <div>
                <h2 className="text-tertiary max-w-[80%] m-auto font-size py-2">
                  your Replie has been added successfully!
                </h2>
              </div>
            </div>
            <div className="  flex justify-center items-start text-center pt-16 text-primary ">
              <h2
                onClick={() => setSuccessPopUp(false)}
                className="capitalize text-[14px] md:text-[16px] font-SoraS relative cursor-pointer linebutton"
              >
                Read other comments
              </h2>
            </div>
            {/* remove button */}
            <div
              onClick={() => setSuccessPopUp(false)}
              className=" cursor-pointer absolute bg-error hover:bg-error/90 duration-500 ease-out w-[50px] md:w-[70px] h-[50px] md:h-[70px] top-0 right-0 translate-y-[40%] -translate-x-[15px] md:-translate-y-1/2 md:-translate-x-[40%] flex justify-center items-center"
            >
              <AiOutlinePlus className="flex justify-center items-center text-tertiary scale-[1.5] md:scale-[2] rotate-45" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  return (
    <div>
      <div>
        {/* popup */}
        <div
          onClick={() => {
            setReplieCommentPopUp(false);
            setSuccessPopUp(false);
            clear();
          }}
          className={
            replieCommentPopup || successPopUp
              ? "absolute z-[1000] purple-full-width  backdrop-blur-[10px] bg-secondary/20 top-0 left-0 h-full w-full opacity-100  duration-500 ease-in-out"
              : "absolute z-[1000] purple-full-width  backdrop-blur-[10px] bg-secondary/20 top-0 left-0 h-full w-full opacity-0 pointer-events-none duration-500 ease-in-out"
          }
        ></div>
        <div
          className={
            replieCommentPopup
              ? "  -translate-y-[0%]  opacity-100 w-full md:w-full lg:w-[75%] xl:w-[60%]  2xl:w-[50%] h-full md:h-[80%]  m-auto duration-500 ease-in-out fixed inset-0 z-[10000] flex justify-center items-center"
              : "  translate-y-[200%] opacity-0  w-full md:w-full lg:w-[75%] xl:w-[60%]  2xl:w-[50%] h-full md:h-[80%]  m-auto duration-500 ease-in-out fixed inset-0 z-[10000] flex justify-center items-center"
          }
        >
          <div className="w-full md:w-full lg:w-full xl:w-full  2xl:w-full h-full md:h-full">
            <div className="relative md:static px-[15px] w-full h-full  overflow-y-scroll flex justify-center items-start  py-28 md:py-0 md:px-0 z-[1000] bg-tertiary duration-500 ease-in-out">
              <div className="md:px-[60px] md:py-[90px] w-full">
                <h2 className="font-size">Write a Reply</h2>
                {currentComment?.map((comment) => {
                  return (
                    <div
                      key={comment._id}
                      className="mt-10  flex gap-x-0 md:gap-x-4"
                    >
                      <div className="bg-primary-0 border-[1px] border-primary w-full px-[20px] md:px-[40px] py-[20px] text-[14px] md:text-[16px] font-SoraR">
                        <div className="flex justify-between items-center">
                          <div className="flex capitalize justify-center items-center gap-x-4">
                            <Link
                              to={`/users/${comment.User_id}`}
                              ref={ref}
                              className="w-[50px]  flex-none h-[50px] md:w-[50px]  md:h-[50px]"
                            >
                              {inView ? (
                                <div className="w-full h-full opacity-100 duration-500 ease-in-out">
                                  {usersList?.[0]?.picture === "" ? (
                                    <div
                                      title={usersList?.[0]?.firstName}
                                      className="cursor-pointer w-12 h-12 text-tertiary bg-primary rounded-full relative z-[50] flex justify-center items-center"
                                    >
                                      {usersList?.[0]?.firstName?.[0]}{" "}
                                    </div>
                                  ) : (
                                    <img
                                      title={usersList?.[0]?.firstName}
                                      className="w-full h-full cursor-pointer object-cover rounded-full"
                                      src={usersList?.[0]?.picture}
                                      alt={usersList?.[0]?.firstName}
                                      referrerPolicy="no-referrer"
                                    />
                                  )}
                                </div>
                              ) : (
                                <div className="flex justify-center items-center h-full w-full rounded-full opacity-20 scale-90 rectangle duration-[0] ease-in-out object-cover">
                                  <Loadinguser />
                                </div>
                              )}
                            </Link>
                            <div className="flex flex-wrap justify-start items-center gap-x-4">
                              <div>
                                <Link
                                  title={usersList?.[0]?.firstName}
                                  to={`/users/${comment.User_id}`}
                                  className="flex-1 line line-clamp-1 font-SoraS  cursor-pointer text-[15px] md:text-[16px]"
                                >
                                  {usersList?.[0]?.firstName}
                                </Link>
                              </div>
                              {currentNovel?.User_id === comment?.User_id && (
                                <div className="bg-primary duration-500 ease-in-out hover:bg-primary/90 px-6 py-1 relative">
                                  <h2 className="capitalize text-[13px] text-tertiary">
                                    Author
                                  </h2>
                                  <div className="h-[10px] w-[10px] bg-white rounded-full absolute top-0 right-0 -translate-y-1/2 translate-x-1/2">
                                    <div className="h-[10px] w-[10px] bg-white animate-ping rounded-full absolute inset-0 "></div>
                                  </div>
                                </div>
                              )}
                              <div
                                data-tip
                                data-for={usersList?.[0]?._id}
                                className="relative flex justify-center items-center "
                              >
                                <span>
                                  <ReactTooltip
                                    id={usersList?.[0]?._id}
                                    className="custom-color-no-arrow"
                                    delayHide={100}
                                    textColor="#D9D9D9"
                                    backgroundColor="#1d1d1d"
                                    effect="solid"
                                  >
                                    <span>{usersList?.[0]?.badgeName}</span>
                                  </ReactTooltip>
                                </span>
                                <span>
                                  <div
                                    className="zoombadge opacity-100 rounded-full blur-[40px]"
                                    dangerouslySetInnerHTML={{
                                      __html: usersList?.[0]?.badgeSvg,
                                    }}
                                  />
                                </span>
                                <span>
                                  <div
                                    className="zoombadge absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                                    dangerouslySetInnerHTML={{
                                      __html: usersList?.[0]?.badgeSvg,
                                    }}
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="md:mt-[10px] mt-[10px] font-SoraR flex gap-x-0 md:gap-x-4">
                          <div className="w-0 md:w-[50px] "></div>
                          <p className="text-[14px] line-clamp-3 break-words flex-1 md:text-[16px] font-SoraR">
                            {comment.comment}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
                <form onSubmit={handleSubmit} className="mt-8">
                  <div className="flex flex-col gap-y-4">
                    <div className="relative">
                      <textarea
                        className="text-[14px] sm:text-[16px] h-[500px] md:h-[300px] resize-none w-full outline-none bg-primarys p-4 md:p-8 placeholder:text-secondary/60"
                        placeholder="What's your thoughts?"
                        value={replyCommentForm.comment}
                        maxLength={800}
                        onChange={(e) => {
                          setReplyCommentForm({
                            ...replyCommentForm,
                            comment: e.target.value,
                            Replie_id: commentId,
                            ReplieX2_id: "",
                            Novel_id: id,
                            likes: [],
                            approved: false,
                          });
                        }}
                        cols="20"
                        rows="10"
                      ></textarea>
                      <div
                        className={
                          replyCommentForm?.comment?.length > 600
                            ? "text-primary text-[14px] sm:text-[16px] absolute bottom-0 right-0 py-4 md:py-6 px-4 md:px-8"
                            : "text-secondary text-[14px] sm:text-[16px] absolute bottom-0 right-0 py-4 md:py-6 px-4 md:px-8"
                        }
                      >
                        {replyCommentForm?.comment?.length}/800
                      </div>
                    </div>
                    <button
                      disabled={submitComment}
                      className="z-10 font-SoraS Purple-btn-effect bg-primary hover:bg-primary/90 duration-500 ease-in-out relative w-full h-[52px] text-tertiary capitalize"
                    >
                      {submitComment ? <Loading /> : "Post Reply Comment"}
                    </button>
                  </div>
                </form>
                {/* errors */}
                <div>
                  <div
                    className={
                      error
                        ? "bg-error text-[14px] sm:text-[16px]  capitalize opacity-100 duration-500 ease-in-out translate-y-0  w-full py-4 flex items-center px-4 md:px-8 text-tertiary md:mt-6 mt-8"
                        : "bg-error text-[14px] sm:text-[16px]  pointer-events-none opacity-0 -translate-y-10 duration-500 ease-in-out capitalize  w-full h-0 flex items-center px-4 md:px-8 text-tertiary  mt-0"
                    }
                  >
                    <h5>Your replie must be at least 50 characters!</h5>
                  </div>
                </div>
              </div>
              <div
                onClick={() => {
                  setReplieCommentPopUp(false);
                  clear();
                }}
                className=" cursor-pointer absolute bg-error hover:bg-error/90 duration-500 ease-out w-[50px] md:w-[70px] h-[50px] md:h-[70px] top-0 right-0 translate-y-[40%] -translate-x-[15px] md:-translate-y-1/2 md:-translate-x-[40%] flex justify-center items-center"
              >
                <AiOutlinePlus className="flex justify-center items-center text-tertiary scale-[1.5] md:scale-[2] rotate-45" />
              </div>
            </div>
          </div>
        </div>
        {successmessage}
      </div>
    </div>
  );
}

export default WriteReplyReviewForm;
function Loading() {
  return (
    <div className="flex justify-center items-center scale-75">
      <div role="status">
        <svg
          aria-hidden="true"
          className=" w-8 h-8 text-tertiary animate-spin fill-primary"
          viewBox="0 0 100 101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor"
          ></path>
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill"
          ></path>
        </svg>
      </div>
      <span className="pl-4">Loading...</span>
    </div>
  );
}
